export const faqList = [
  {
    id: 'faq-1',
    question: '91n.con 是什么网站？',
    answer: '91n.con 是一个综合性数字内容与社区服务平台，提供丰富的多媒体内容、用户互动社区及个性化推荐服务。平台以优质内容为核心，为用户打造安全、便捷、高效的在线体验。',
  },
  {
    id: 'faq-2',
    question: '为什么有时候无法访问 91n.con？',
    answer: '由于网络环境变化或DNS解析问题，部分用户可能遇到暂时无法访问的情况。建议您：1）尝试使用本页提供的镜像地址；2）清除浏览器缓存和DNS缓存；3）更换网络环境后重试；4）使用最新推荐的官方入口。',
  },
  {
    id: 'faq-3',
    question: '如何确认我访问的是真正的官方入口？',
    answer: '请认准本页公布的官方地址列表。真正的91n.con官方入口具有以下特征：1）URL域名以 91n.con 结尾；2）页面底部有官方版权信息；3）HTTPS安全连接标志；4）与本页发布的地址一致。请勿轻信搜索引擎中非官方推广链接。',
  },
  {
    id: 'faq-4',
    question: '91n.con 的镜像地址和主站有什么区别？',
    answer: '镜像地址是主站的完整复制，内容与功能完全一致。主要区别在于：1）服务器地理位置不同，就近访问可获得更快速度；2）各镜像节点独立运行，主站故障时镜像可正常使用；3）部分镜像针对特定地区做了网络优化。建议优先使用主站，访问困难时切换镜像。',
  },
  {
    id: 'faq-5',
    question: '地址列表多久更新一次？',
    answer: '我们的地址监控系统7×24小时持续检测各节点运行状态。一旦发现地址变更或新增节点，页面会在30分钟内自动同步更新。同时建议您收藏本页作为永久入口导航，随时获取最新信息。',
  },
  {
    id: 'faq-6',
    question: '手机端可以访问 91n.con 吗？',
    answer: '完全可以。91n.con 已全面适配移动端，支持 iOS、Android 等主流手机系统。您可以直接使用手机浏览器访问本页提供的任意官方地址，获得与桌面端一致的使用体验。部分镜像节点还针对移动网络做了专项优化。',
  },
  {
    id: 'faq-7',
    question: '访问时提示"连接不安全"怎么办？',
    answer: '如果您使用的是本页提供的官方地址，且浏览器显示安全警告，可能原因包括：1）系统时间不正确，请校准设备时间；2）网络中间设备干扰，尝试切换网络；3）浏览器缓存问题，清除缓存后重试。官方入口均采用行业标准加密，请放心访问。',
  },
  {
    id: 'faq-8',
    question: '如何获取最新的地址更新通知？',
    answer: '最可靠的方式是将本导航页（91n.con官方入口导航）添加为浏览器书签，并定期访问。同时您可以关注我们的官方社交媒体账号获取即时更新通知。我们不通过短信或第三方渠道发送地址变更信息，请谨防诈骗。',
  },
];